import { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PriceStatus } from '@utriper/core';
import { Edit } from '@mui/icons-material';
import { usePriceGroupTab } from 'core/contexts/priceGroupTab';
import { AlertDialog, Chip, CircularIndeterminate } from '@utriper/core-ui';
import { Button, Grid2, IconButton, Typography, useMediaQuery } from '@mui/material';
import Layout from 'components/Layout';
import PriceGroupFilters from './components/PriceGroupFilters';
import PriceGroupCards from './components/PriceGroupCards';
import PriceGroupEmptyState from '../components/PriceGroupEmptyState';
import PriceGroupNoData from '../components/PriceGroupNoData';
import PriceGroupTabForm from '../components/PriceGroupTabForm';
import { Section } from '../styles';

const PriceListIdPage = () => {
    const { id } = useParams();
    const priceGroupTabId = parseInt(id);
    const history = useHistory();
    const { t: translate, i18n } = useTranslation();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const { getPriceGroupTabById, getPriceGroups, getStatusColor, handleOpenUpdateForm, loading, loadingPriceGroups, priceGroupTab, priceGroups, allPriceGroupCount, pgNameFilterDebounce, pgNameFilter, pgStatusFilter, pgTypeFilter, pagePg, openUpdateForm } = usePriceGroupTab();

    useEffect(() => {
        if (Number.isInteger(priceGroupTabId)) {
            getPriceGroupTabById(priceGroupTabId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [priceGroupTabId]);

    useEffect(() => {
        if (Number.isInteger(priceGroupTabId)) {
            getPriceGroups(priceGroupTabId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [priceGroupTabId, pgNameFilterDebounce, pgStatusFilter, pgTypeFilter, pagePg]);

    const statusLabel = Number.isInteger(priceGroupTab?.status) ? PriceStatus.getTranslatedName(PriceStatus.status, priceGroupTab?.status, i18n.language) : '';
    const statusColor = getStatusColor(priceGroupTab?.status);
    const handleWizard = () => {
        history.push(`/price-list/${priceGroupTabId}/price-group/add`);
    };

    return (
        <Layout>
            {loading ? (
                <CircularIndeterminate centered />
            ) : (
                <Section>
                    {/* Title */}
                    <Grid2 container justifyContent="space-between" alignItems="center" size={12}>
                        <Grid2 container direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" size={10}>
                            <Grid2 container justifyContent="flex-start" alignItems="center" gap="8px" size={12} flexWrap="nowrap">
                                <Typography fontSize={20} fontWeight={900} sx={{ color: '#131313' }} noWrap>
                                    {priceGroupTab?.name}
                                </Typography>
                                <Chip label={statusLabel} sx={{ background: `${statusColor}40`, color: `${statusColor}`, padding: '8px 4px', borderRadius: '4px' }} />
                            </Grid2>
                            {priceGroupTab?.description && (
                                <Grid2 container justifyContent="flex-start" alignItems="center" gap="8px" size={12}>
                                    <Typography fontSize={16} fontWeight={500} sx={{ color: '#131313bf' }} noWrap>
                                        {priceGroupTab.description}
                                    </Typography>
                                </Grid2>
                            )}
                        </Grid2>
                        <Grid2 container justifyContent="flex-end" alignItems="center" size={2}>
                            {isMobile ? (
                                <IconButton onClick={() => handleOpenUpdateForm()}>
                                    <Edit sx={{ color: '#131313' }} />
                                </IconButton>
                            ) : (
                                <Button
                                    sx={{
                                        padding: '8px 14px',
                                        backgroundColor: '#131313',
                                        fontWeight: 600,
                                        width: { xs: '100%', md: 'fit-content' },
                                        textTransform: 'none',
                                    }}
                                    variant="contained"
                                    startIcon={<Edit />}
                                    onClick={() => handleOpenUpdateForm()}
                                >
                                    {translate('price_group_tab_id.edit_button')}
                                </Button>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Price Groups Filters */}
                    <PriceGroupFilters handleWizard={handleWizard} />

                    {/* Cards */}
                    {loadingPriceGroups ? <CircularIndeterminate centered /> : priceGroups?.length > 0 ? <PriceGroupCards /> : allPriceGroupCount <= 0 ? <PriceGroupEmptyState handleWizard={handleWizard} /> : pgNameFilter?.length > 0 || pgStatusFilter?.length > 0 || pgTypeFilter?.length > 0 ? <PriceGroupNoData /> : ''}
                </Section>
            )}

            {/* Add Form */}
            <AlertDialog open={openUpdateForm} handleClose={() => handleOpenUpdateForm()} hideTitle hideActions maxWidth="sm" fullWidth dialogContent={<PriceGroupTabForm priceGroupTabId={priceGroupTabId} formInitialValues={priceGroupTab} />} />
        </Layout>
    );
};

export default PriceListIdPage;
